import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
} from "@material-ui/core";

const SECCIONES = [
  { key: "agregados", label: "Agregados", color: "success.main" },
  { key: "actualizados", label: "Actualizados", color: "info.main" },
  { key: "quitados", label: "Quitados", color: "text.secondary" },
  {
    key: "requierenRevision",
    label: "Requieren revisión",
    color: "error.main",
  },
];

export default function ResumenCambiosDialog({ cambios, open, onClose }) {
  if (!cambios) return null;
  const conContenido = SECCIONES.filter(
    (s) => (cambios[s.key]?.length ?? 0) > 0,
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Planes actualizados</DialogTitle>
      <DialogContent dividers>
        {conContenido.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            Los planes ya estaban al día. No hubo cambios.
          </Typography>
        ) : (
          conContenido.map((s) => (
            <Box key={s.key} sx={{ mb: 2 }}>
              <Typography variant="subtitle2" sx={{ color: s.color, mb: 0.5 }}>
                {s.label} ({cambios[s.key].length})
              </Typography>
              <List dense disablePadding>
                {cambios[s.key].map((c, idx) => (
                  <ListItem key={`${c.rutCliente}-${idx}`} disableGutters>
                    <ListItemText
                      primary={`${c.nombreCliente} — ${c.nombrePlan}`}
                      secondary={c.motivo || undefined}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          ))
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
}
